import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { orderCancellationListGuard } from './page/order-cancellation/order-cancellation-list/order-cancellation-list.guard';
import { orderCancellationSuccessGuard } from './page/order-cancellation/order-cancellation-success/order-cancellation-success.guard';
import {
  homepageUrl,
  newsletterUrl,
  orderCancellationUrl,
  postalCodeUrl,
  shopUrl,
} from '@app/helpers';
import { OciSessionStartGuard } from '@app/services';
import { EmporixCheckoutPaymentConfirmationGuard } from 'haba-emporix';
import { NewsletterSubscriptionSuccessComponent } from 'src/app/page/newsletter/newsletter-subscription-success/newsletter-subscription-success.component';
import { NewsletterComponent } from 'src/app/page/newsletter/newsletter/newsletter.component';
import { PaymentConfirmationComponent } from './checkout/payment-confirmation/payment-confirmation.component';
import { HomepageComponent } from './contentful';
import { ShopPageComponent } from './contentful/shop-page/shop-page.component';
import { PostalCodeComponent } from './page/postal-code/postal-code.component';
import { customProductUrlMatcher } from './product/custom-url/custom-url.matcher';
import { HabaCmsProductPageGuard } from './product/guards/haba-cms-product-page-guard.service';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: 's',
          redirectTo: homepageUrl,
          pathMatch: 'full',
        },
        {
          path: homepageUrl,
          component: HomepageComponent,
        },
        {
          path: 'styleguide',
          loadChildren: () =>
            import('./@styleguide/styleguide.module').then((m) => m.StyleguideModule),
        },
        {
          path: 'search',
          loadChildren: () =>
            import('src/app/page/search-page/search-page.module').then((m) => m.SearchPageModule),
        },
        {
          path: 'c',
          redirectTo: 'c/',
          pathMatch: 'full',
        },
        {
          path: 'c',
          loadChildren: () =>
            import('src/app/search/category-page/category-page.module').then(
              (m) => m.CategoryPageModule
            ),
        },
        {
          path: 'wishlist',
          loadChildren: () =>
            import('src/app/wishlist/wishlist-custom.module').then((m) => m.WishlistCustomModule),
        },
        {
          path: newsletterUrl.subscription,
          component: NewsletterComponent,
        },
        {
          path: newsletterUrl.subscriptionSuccess,
          component: NewsletterSubscriptionSuccessComponent,
        },
        {
          path: `s/${postalCodeUrl}`,
          redirectTo: postalCodeUrl,
          pathMatch: 'full',
        },
        {
          path: postalCodeUrl,
          component: PostalCodeComponent,
        },
        {
          path: 'checkout/payment-confirmation',
          canActivate: [EmporixCheckoutPaymentConfirmationGuard],
          component: PaymentConfirmationComponent,
        },
        {
          path: shopUrl,
          component: ShopPageComponent,
        },
        {
          path: 'cookies',
          loadComponent: () =>
            import('src/app/page/cookie-info/cookie-info.component').then(
              (c) => c.CookieInfoComponent
            ),
        },
        {
          matcher: customProductUrlMatcher,
          loadComponent: () =>
            import('./product/product-detail/product-details.component').then(
              (c) => c.ProductDetailsComponent
            ),
          canActivate: [HabaCmsProductPageGuard],
        },
        {
          path: 'oci/start-session',
          canActivate: [OciSessionStartGuard],
          children: [],
        },
        {
          path: 's/service-vorteile/retoure',
          loadComponent: () =>
            import('./returns/returns.component').then((c) => c.ReturnsComponent),
        },
        {
          path: orderCancellationUrl.slice(1),
          loadComponent: () =>
            import(
              './page/order-cancellation/order-cancellation-form/order-cancellation-form.component'
            ).then((c) => c.OrderCancellationFormComponent),
        },
        {
          path: orderCancellationUrl.slice(1) + '/list',
          canActivate: [orderCancellationListGuard],
          loadComponent: () =>
            import(
              './page/order-cancellation/order-cancellation-list/order-cancellation-list.component'
            ).then((c) => c.OrderCancellationListComponent),
        },
        {
          path: orderCancellationUrl.slice(1) + '/success',
          canActivate: [orderCancellationSuccessGuard],
          loadComponent: () =>
            import(
              './page/order-cancellation/order-cancellation-success/order-cancellation-success.component'
            ).then((c) => c.OrderCancellationSuccessComponent),
        },
      ],
      {
        anchorScrolling: 'disabled',
        initialNavigation: 'enabledBlocking',
        scrollPositionRestoration: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
